/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSubskritUp: {
  name: 'subskrit-up';
  data: string;
} = {
  name: 'subskrit-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 12h6M2 15 7 4l5 11M14 5h-2s2-1.5 2-3M14 2a1 1 0 1 0-2 0" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
};
